module.exports = __webpack_public_path__ + "img/microsite-VN.da7d43f6.gif";